import React from 'react';
import AuthGate from './components/AuthGate';

function App() {
  return <AuthGate />;
}

export default App;
